import React from "react";
import { Redirect, Route } from "react-router-dom";
import { getCurrentCulture, isNullOrWhitespace } from "@utils";
import { redirect } from "@state";
import { DefaultPath } from "@utils/common/defaultRoutePathsEnum";
export default function LegacyRedirects() {
	// will get from url, if not will try to get from cookie, if not it will use default culture specified in appSettings
	const currentCulture = getCurrentCulture();

	if (!isNullOrWhitespace(window.location.hash)) {
		//if hash exists we need to remove it and redirect user to url without hash with replace = true so we remove 404 entry from history list
		const locationWithoutHash = window.location.href.split("#")[1];
		redirect(locationWithoutHash, true);
	}

	/* v1 routes */
	// constants used for route path definitions (regex) - (everything after culture)
	// every v1 route has localization in 7 different languages (on desktop)

	/*
		NOTES:
		liveCasinoCashier should lead to home page, our fund transfer is inside casino page,
		private routes direct to login if user is not logged in
		routes that are not accessible by user default to home page (e.g. betting activity, accept terms, account verification)
		#need to add force password change route, email activation if exists in v1
	*/
	const legacyRoutesDesktop = {
		home: "home|initiale|pocetna|pagina-iniziale|fillestare|baslangic",
		prematch:
			"sports-betting|sportwetten|paris-sportifs|baste-sportive|scommesse-sportive|sportsko-kladjenje|spor-bahisleri",
		live: "live-sports-betting|live-sportwetten|kladjenje-uzivo|scommesse-sportive-live|paris-sportifs-live|canli-spor-bahisler|baste-sportive-live",
		forgotUsername:
			"username-recovery|benutzername-vergessen|zaboravljeno-korisnicko-ime|nome-utente-dimenticato|nom-d'utilisateur-oublie|unutulmus-kullanici-adi|emeri-i-perdorimit-i-harruar",
		forgotPassword:
			"password-recovery|passwort-vergessen|zaboravljena-lozinka|password-dimenticata|mot-de-passe-oublie|unutulmus-sifre|fjalekalimi-i-harruar",
		results:
			"results|ergebnisse|rezultati|risultati|resultats|sonuclar|rezultati",
		myBets: "submitted-bets|abgegebene-wetten|predane-oklade|scommesse-consegnate|paris-transmis|yatirilmis-bahisler|bastet-dorezuara",
		accountStatement:
			"account-statement|kontoauszug|izvod-racuna|estratto-conto|extrait-compte|hesap-dekontu|faqja-e-pageses",
		accountSettings:
			"user-account|kundenkonto|korisnicki-racun|account-utente|compte-utilisateur|kullanici-hesap|llogaria-e-perdoruesit",
		limitsHistory:
			"limits-history|limits-historie|povijest-limita|limits-history|limits-history|limits-history|limits-history",
		deposit: "payment|anzahlung|uplata|deposito|payement|mevduat|pagesa",
		withdrawal:
			"payout|auszahlung|isplata|prelievo|retrait|para-cekme|paguar",
		paymentOptions:
			"payment-options|zahlungsarten|opcije-placanja|modalita-di-pagamento|methodes-payement|odeme-metotlari|metoda-pageses",
		accountActivation:
			"account-activation|kontoaktivierung|aktivacija-racuna|attivazione-account|activation-comptes|hesap-etkinlestirme|aktivizimi-llogarise",
		registration:
			"registration|registrierung|registracija|registrazione|enregistrement|kayit-tescil-hesap|rregjistrimi-perdoruesit",
		contact: "contact|kontakt|kontakt|contatto|contact|temas|kontakt",
		aboutUs:
			"about-us|uber-uns|o-nama|chi-siamo|sur-nous|hakkimizda|per-ne",
		responsibleGaming:
			"responsible-gaming|verantwortungsvoll-spielen|odgovorno-igranje|gioca-responsabilmente|jeu-responsqble|sorumlu-oynama|loje-me-pergjegjesi",
		termsAndConditions:
			"terms-and-conditions|allgemeine-geschaftsbedingungen|opci-uvjeti-poslovanja|termini-e-condizioni-d'utilizzo|conditions-generales|calisma-genel-sartlari|kushtet-pergjithshme-punes",
		privacy:
			"privacy-policy|datenschutz|zastita-privatnosti|tutela-della-riservatezza|protection-confidentialite|gzlilik-korunmasi|mbrojtja-e-privatesise",
		bettingRules:
			"betting-rules|wettbestimmungen|pravila-kladjenja|betting-rules|betting-rules|betting-rules|betting-rules",
		ourPartners:
			"partners|partner|partneri|partner|partenaires|partner|partnere",
		bonusTerms:
			"bonus-terms|bonusbedingungen|bonus-uvjeti|bonus-condizioni|bonus-conditions|bonus-sartlari|kushtet-bonus",
		help: "help|hilfe|pomoc|aiuto|assistance|yardim|ndihme",
		bettingActivity:
			"betting-review|betting-review|betting-review|betting-review|betting-review|betting-review|betting-review",
		termsUpdateReview:
			"terms-update|terms-update|terms-update|terms-update|terms-update|terms-update|terms-update|",
		accountVerification:
			"account-verification|konto-verifikation|verifikacija-racuna|verifica-dell-account|verification-de-compte|hesap-dogrulama|verifikimi-i-llogarise",
		offer: "offer|wettprogramm|ponuda|offerta|offre|sunum|ofertat",
		liveCasino:
			"live-casino|live-casino|live-casino|casino-live|casino-live|canli-casino|casino-live",
		liveCasinoCashier:
			"funds-transfer|mitteluberweisung|transfer|funds-transfer|funds-transfer|funds-transfer|funds-transfer",
		liveCasinoGamingHistory:
			"gaming-history|spielhistorie|casino-povijest|gaming-history|gaming-history|gaming-history|gaming-history",
		onlineCasino:
			"online-casino|online-casino|online-casino|casino-online|casino-enligne|online-casino|casino-online",
		accountRecheck:
			"user-profile-recheck|user-profile-recheck|user-profile-recheck|user-profile-recheck|user-profile-recheck|user-profile-recheck|user-profile-recheck",
		limitIncrease: "credit-rating-check|credit-rating-result",
		playerMoneyProtection:
			"player-money-protection|player-money-protection|player-money-protection|skydda-pengar",
		moneyProtection: "money-protection|sv/skydda-pengar",
		whistleblowingChannel:
			"whistleblowing-channel|whistleblowing-kanal|whistleblowing-kanal|whistleblowing-kanal",

		whistleblowingReport:
			"whistleblowing-report|whistleblowing-rapport|whistleblowing-bericht|prijava-nepravilnosti",
		gamingSummary: "gaming-summary|spelrapport",
	};

	return (
		<>
			{/* v1 routes - AFFILIATE */}

			<Route
				exact
				path="/affiliate/:culture/:afc"
				render={({ match: { params } }) => {
					return (
						<Redirect
							to={{
								pathname: `/${params.culture}/auth/register`,
								search: `?afc=${params.afc}&reload=true`,
							}}
						/>
					);
				}}
			/>

			<Route
				exact
				path="/affiliate/:afc"
				render={({ match: { params } }) => {
					return (
						<Redirect
							to={{
								pathname: `/${currentCulture}/auth/register`,
								search: `?afc=${params.afc}`,
							}}
						/>
					);
				}}
			/>

			{/* v1 routes - DESKTOP*/}
			{/* home  */}
			<Route
				path={`/:culture/(${legacyRoutesDesktop.home})`}
				render={({ match }) => (
					<Redirect to={`/${match.params.culture}/home`} />
				)}
			/>

			{/* prematch  */}
			<Route
				path={`/:culture/(${legacyRoutesDesktop.prematch})`}
				render={({ match }) => (
					<Redirect to={`/${match.params.culture}/sports`} />
				)}
			/>
			{/* live  */}
			<Route
				path={`/:culture/(${legacyRoutesDesktop.live})`}
				render={({ match }) => (
					<Redirect to={`/${match.params.culture}/live`} />
				)}
			/>

			{/* offer */}
			<Route
				path={`/:culture/(${legacyRoutesDesktop.offer})`}
				render={({ match }) => (
					<Redirect to={`/${match.params.culture}/offer`} />
				)}
			/>

			{/* forgot-username */}
			<Route
				path={`/:culture/(${legacyRoutesDesktop.forgotUsername})`}
				render={({ match }) => (
					<Redirect
						to={`/${match.params.culture}/auth/forgot-username`}
					/>
				)}
			/>

			{/* Account-recheck + */}
			<Route
				path={`/:culture/(${legacyRoutesDesktop.accountRecheck})`}
				render={() => (
					<Redirect to={`/${currentCulture}/user-profile-recheck`} />
				)}
			/>

			{/* Limit increase */}
			<Route
				path={`/:culture/(${legacyRoutesDesktop.limitIncrease})`}
				render={() => (
					<Redirect to={`/${currentCulture}/limit-increase`} />
				)}
			/>

			{/* forgot-password */}
			<Route
				path={`/:culture/(${legacyRoutesDesktop.forgotPassword})`}
				render={({ match }) => (
					<Redirect
						to={`/${match.params.culture}/auth/forgot-password`}
					/>
				)}
			/>

			{/* registration */}
			<Route
				path={`/:culture/(${legacyRoutesDesktop.registration})`}
				render={({ match, location: { search } }) => (
					<Redirect
						to={{
							pathname: `/${match.params.culture}/auth/register`,
							search: search,
						}}
					/>
				)}
			/>

			{/* results */}
			<Route
				path={`/:culture/(${legacyRoutesDesktop.results})`}
				render={({ match }) => (
					<Redirect to={`/${match.params.culture}/results`} />
				)}
			/>

			{/* contact */}
			<Route
				path={`/:culture/(${legacyRoutesDesktop.contact})`}
				render={({ match }) => (
					<Redirect to={`/${match.params.culture}/info/contact`} />
				)}
			/>

			{/* my bets */}
			<Route
				path={`/:culture/(${legacyRoutesDesktop.myBets})`}
				render={({ match }) => (
					<Redirect to={`/${match.params.culture}/my-bets`} />
				)}
			/>

			{/* account-statement */}
			<Route
				path={`/:culture/(${legacyRoutesDesktop.accountStatement})`}
				render={({ match }) => (
					<Redirect
						to={`/${match.params.culture}/account-statement`}
					/>
				)}
			/>

			{/* account settings */}
			<Route
				path={`/:culture/(${legacyRoutesDesktop.accountSettings})`}
				render={({ match }) => (
					<Redirect
						to={`/${match.params.culture}/account-settings`}
					/>
				)}
			/>

			{/* account-settings/limits-history */}
			<Route
				path={`/:culture/(${legacyRoutesDesktop.limitsHistory})`}
				render={({ match }) => (
					<Redirect
						to={`/${match.params.culture}/account-settings/limits-history`}
					/>
				)}
			/>

			{/* deposit */}
			<Route
				path={`/:culture/(${legacyRoutesDesktop.deposit})`}
				render={({ match }) => (
					<Redirect to={`/${match.params.culture}/deposit`} />
				)}
			/>

			{/* withdrawal */}
			<Route
				path={`/:culture/(${legacyRoutesDesktop.withdrawal})`}
				render={({ match }) => (
					<Redirect to={`/${match.params.culture}/withdrawal`} />
				)}
			/>

			{/* games(casino) */}
			<Route
				path={`/:culture/(${legacyRoutesDesktop.onlineCasino})`}
				render={({ match }) => (
					<Redirect to={`/${match.params.culture}/games`} />
				)}
			/>

			{/* games(live-casino) */}
			<Route
				path={`/:culture/(${legacyRoutesDesktop.liveCasino})`}
				render={({ match }) => (
					<Redirect to={`/${match.params.culture}/live-games`} />
				)}
			/>

			{/* gaming history */}
			<Route
				path={`/:culture/(${legacyRoutesDesktop.liveCasinoGamingHistory})`}
				render={({ match }) => (
					<Redirect
						to={`/${match.params.culture}/gaming-history/games`}
					/>
				)}
			/>

			{/* account-verification */}
			<Route
				path={`/:culture/(${legacyRoutesDesktop.accountVerification})`}
				render={({ match }) => (
					<Redirect
						to={`/${match.params.culture}/account-settings/account-verification`}
					/>
				)}
			/>

			{/* info pages */}
			{/* payment-options */}
			<Route
				path={`/:culture/(${legacyRoutesDesktop.paymentOptions})`}
				render={({ match }) => (
					<Redirect to={`/${match.params.culture}/payment-options`} />
				)}
			/>

			{/* about-us */}
			<Route
				path={`/:culture/(${legacyRoutesDesktop.aboutUs})`}
				render={({ match }) => (
					<Redirect to={`/${match.params.culture}/info/about-us`} />
				)}
			/>

			{/* responsible-gaming */}
			<Route
				path={`/:culture/(${legacyRoutesDesktop.responsibleGaming})`}
				render={({ match }) => (
					<Redirect
						to={`/${match.params.culture}/info/responsible-gaming`}
					/>
				)}
			/>

			{/* terms-and-conditions */}
			<Route
				path={`/:culture/(${legacyRoutesDesktop.termsAndConditions})`}
				render={({ match }) => (
					<Redirect
						to={`/${match.params.culture}/info/terms-and-conditions`}
					/>
				)}
			/>

			{/* privacy */}
			<Route
				path={`/:culture/(${legacyRoutesDesktop.privacy})`}
				render={({ match }) => (
					<Redirect to={`/${match.params.culture}/info/privacy`} />
				)}
			/>

			{/* betting-rules */}
			<Route
				path={`/:culture/(${legacyRoutesDesktop.bettingRules})`}
				render={({ match }) => (
					<Redirect
						to={`/${match.params.culture}/info/betting-rules`}
					/>
				)}
			/>

			{/* our-partners */}
			<Route
				path={`/:culture/(${legacyRoutesDesktop.ourPartners})`}
				render={({ match }) => (
					<Redirect
						to={`/${match.params.culture}/info/our-partners`}
					/>
				)}
			/>

			{/* bonus-terms */}
			<Route
				path={`/:culture/(${legacyRoutesDesktop.bonusTerms})`}
				render={({ match }) => (
					<Redirect
						to={`/${match.params.culture}/info/bonus-terms`}
					/>
				)}
			/>

			{/* help */}
			<Route
				path={`/:culture/(${legacyRoutesDesktop.help})`}
				render={({ match }) => (
					<Redirect to={`/${match.params.culture}/info/help`} />
				)}
			/>

			<Route
				path={`/:culture/(${legacyRoutesDesktop.playerMoneyProtection})`}
				render={({ match }) => (
					<Redirect
						to={`/${match.params.culture}/info/player-money-protection`}
					/>
				)}
			/>
			{/* home fallbacks */}
			{/* betting-activity, terms update, account-activation */}
			<Route
				path={[
					`/:culture/(${legacyRoutesDesktop.bettingActivity})`,
					`/:culture/(${legacyRoutesDesktop.termsUpdateReview})`,
					`/:culture/(${legacyRoutesDesktop.accountActivation})`,
				]}
				render={({ match }) => (
					<Redirect to={`/${match.params.culture}/home`} />
				)}
			/>

			{/* v1 routes - MOBILE */}
			{/* commented this for testing due to always going to #home */}
			{/* <Redirect from="/#home" to={`/${currentCulture}/home/full`} /> */}

			{/* home + */}
			<Route
				path={`/home`}
				render={() => (
					<Redirect to={`/${currentCulture}/${DefaultPath.HOME}`} />
				)}
			/>

			{/* prematch + */}
			<Route
				path={`/betting/sports`}
				render={() => (
					<Redirect to={`/${currentCulture}/sports/full`} />
				)}
			/>

			{/* live +*/}
			<Route
				path={`/betting/live`}
				render={() => (
					<Redirect to={`/${currentCulture}/live/matches`} />
				)}
			/>

			<Route
				path={`/live/events`}
				render={() => (
					<Redirect to={`/${currentCulture}/live/matches`} />
				)}
			/>
			<Route
				path={`/:culture/live/events/event/:eventId`}
				render={({ match }) => (
					<Redirect
						to={`/${currentCulture}/${DefaultPath.LIVE}/${match.params.eventId}`}
					/>
				)}
			/>

			{/* forgot-username +*/}
			<Route
				path={`/username-recovery`}
				render={() => (
					<Redirect to={`/${currentCulture}/auth/forgot-username`} />
				)}
			/>

			{/* forgot-password +*/}
			<Route
				path={`/password-recovery`}
				render={() => (
					<Redirect to={`/${currentCulture}/auth/forgot-password`} />
				)}
			/>

			{/* registration +*/}
			<Route
				path={`/registration`}
				render={({ location: { search } }) => (
					<Redirect
						to={{
							pathname: `/${currentCulture}/auth/register`,
							search: search,
						}}
					/>
				)}
			/>

			{/* results +*/}
			<Route
				path={`/results`}
				render={() => <Redirect to={`/${currentCulture}/results`} />}
			/>

			{/* contact +*/}
			<Route
				path={`/contact`}
				render={() => (
					<Redirect to={`/${currentCulture}/info/contact`} />
				)}
			/>

			{/* my bets +*/}
			<Route
				path={`/user-bets`}
				render={() => <Redirect to={`/${currentCulture}/my-bets`} />}
			/>

			{/* account-statement +*/}
			<Route
				path={`/account-statement`}
				render={() => (
					<Redirect to={`/${currentCulture}/account-statement`} />
				)}
			/>

			{/* account-settings+ (here handled 
				personal data, 
				my bonuses, 
				password change, 
				email change,
				my-limits,
				account-lock,
				automatic-logout
			) */}
			<Route
				path={`/user-settings`}
				render={() => (
					<Redirect to={`/${currentCulture}/account-settings`} />
				)}
			/>

			{/* account-verification +*/}
			<Route
				path={`/account-verification`}
				render={() => (
					<Redirect
						to={`/${currentCulture}/account-settings/account-verification`}
					/>
				)}
			/>
			{/* deposit +*/}
			<Route
				path={[`/deposit`, `/user-deposits`]}
				render={() => <Redirect to={`/${currentCulture}/deposit`} />}
			/>

			{/* withdrawal +*/}
			<Route
				path={[`/withdrawal`, `/user-withdrawals`]}
				render={() => <Redirect to={`/${currentCulture}/withdrawal`} />}
			/>

			{/* gaming history +*/}
			<Route
				path={`/gaming-history`}
				render={() => (
					<Redirect to={`/${currentCulture}/gaming-history/games`} />
				)}
			/>
			<Route
				path={`/gaming-summary`}
				render={() => (
					<Redirect
						to={`/${currentCulture}/account-settings/gaming-summary`}
					/>
				)}
			/>

			{/* search */}

			{/* info pages */}
			{/* payment options +*/}
			<Route
				path={`/info/payment-options`}
				render={() => (
					<Redirect to={`/${currentCulture}/info/payment-options`} />
				)}
			/>

			{/* about-us + */}
			<Route
				path={`/info/about-us`}
				render={() => (
					<Redirect to={`/${currentCulture}/info/about-us`} />
				)}
			/>

			{/* responsible-gaming + */}
			<Route
				path={`/info/responsible-betting`}
				render={() => (
					<Redirect
						to={`/${currentCulture}/info/responsible-gaming`}
					/>
				)}
			/>

			{/* terms-and-conditions + */}
			<Route
				path={`/info/terms-and-conditions`}
				render={() => (
					<Redirect
						to={`/${currentCulture}/info/terms-and-conditions`}
					/>
				)}
			/>

			{/* privacy + */}
			<Route
				path={`/info/privacy-policy`}
				render={() => (
					<Redirect to={`/${currentCulture}/info/privacy`} />
				)}
			/>

			{/* our-partners + */}
			<Route
				path={`/info/partners`}
				render={() => (
					<Redirect to={`/${currentCulture}/info/our-partners`} />
				)}
			/>

			{/* bonus-terms */}
			<Route
				path={`/info/bonus-terms`}
				render={() => (
					<Redirect to={`/${currentCulture}/info/bonus-terms`} />
				)}
			/>

			{/* betting rules + */}
			<Route
				path={`/info/betting-rules`}
				render={() => (
					<Redirect to={`/${currentCulture}/info/betting-rules`} />
				)}
			/>

			{/* account-recheck */}
			<Route
				path={`/user-profile-recheck`}
				render={() => (
					<Redirect to={`/${currentCulture}/user-profile-recheck`} />
				)}
			/>

			<Route
				path={`/credit-rating-check`}
				render={() => (
					<Redirect to={`/${currentCulture}/limit-increase`} />
				)}
			/>

			<Route
				path={`/credit-rating-result`}
				render={() => (
					<Redirect to={`/${currentCulture}/limit-increase`} />
				)}
			/>

			<Route
				path={`/:culture/(${legacyRoutesDesktop.whistleblowingChannel})`}
				render={({ match }) => (
					<Redirect
						to={`/${match.params.culture}/info/whistleblowing-channel`}
					/>
				)}
			/>

			<Route
				path={`/info/(${legacyRoutesDesktop.moneyProtection})`}
				render={() => (
					<Redirect
						to={`/${currentCulture}/info/player-money-protection`}
					/>
				)}
			/>

			<Route
				path={`/:culture/(${legacyRoutesDesktop.whistleblowingReport})`}
				render={({ match }) => (
					<Redirect
						to={`/${match.params.culture}/info/whistleblowing-report`}
					/>
				)}
			/>

			<Route
				path={`/:culture/(${legacyRoutesDesktop.gamingSummary})`}
				render={({ match }) => (
					<Redirect
						to={`/${match.params.culture}/account-settings/gaming-summary`}
					/>
				)}
			/>
			{/* help */}
			{/* no help? */}
		</>
	);
}
